module.exports = __webpack_public_path__ + "img/talk-fullbody.a97361f0.gif";